import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationEN from "./locales/en/translation.json";
import translationPT from "./locales/ptBR/translation.json";

// source: https://react.i18next.com/guides/quick-start
// the translations
const resources = {
  en: {
    translation: translationEN
  },
  ptBR: {
    translation: translationPT
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "ptBR",

    keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
